import { apiRequest } from './client';
import type {
  ApproveAllCountLinesResult, ApproveCountLineInput, ApproveCountLineResult, AssignedCountSheet, CaptureCountLineResult, CountAssignee, CountSalesRefreshResult, CountSheetList,
  CreateCountSheetInput, ManagerCountSheet, SubmitCountSheetResult,
} from '../types/countSheets';

// F4 · Conteos asignados a ciegas con aprobación. Lo que decía el sistema, la diferencia, el bloqueo
// por ventas pendientes y la hora los decide el backend; quien cuenta solo manda lo contado.
const SHEETS = '/api/inventory/count-sheets';
const LINES = '/api/inventory/count-sheet-lines';

export const getCountSheets = (status: 'ACTIVE' | 'CLOSED', storeId?: string) =>
  apiRequest<CountSheetList>(`${SHEETS}?status=${status}${storeId ? `&storeId=${encodeURIComponent(storeId)}` : ''}`);
export const getMyCountSheets = () => apiRequest<{ sheets: AssignedCountSheet[] }>(`${SHEETS}/mine`);
export const getCountAssignees = (storeId: string) => apiRequest<{ users: CountAssignee[] }>(`${SHEETS}/assignees?storeId=${encodeURIComponent(storeId)}`);
// Escrituras: a los 30 s se cortan y la pantalla lo trata como resultado desconocido (reintentar con la misma llave no duplica).
export const createCountSheet = (input: CreateCountSheetInput) =>
  apiRequest<{ sheet: ManagerCountSheet; replayed: boolean }>(SHEETS, { ...json('POST', input), signal: timeoutSignal(30_000) });
export const submitCountSheet = (sheetId: string) =>
  apiRequest<SubmitCountSheetResult>(`${SHEETS}/${encodeURIComponent(sheetId)}/submit`, { ...json('POST', {}), signal: timeoutSignal(30_000) });
export const cancelCountSheet = (sheetId: string) =>
  apiRequest<{ sheet: ManagerCountSheet; replayed: boolean }>(`${SHEETS}/${encodeURIComponent(sheetId)}/cancel`, json('POST', {}));
export const approveAllCountLines = (sheetId: string, input: { staleSalesSyncAcknowledged?: boolean; pendingSupplyAcknowledged?: boolean } = {}) =>
  apiRequest<ApproveAllCountLinesResult>(`${SHEETS}/${encodeURIComponent(sheetId)}/approve-all`, { ...json('POST', input), signal: timeoutSignal(60_000) });
// «Actualizar ventas»: sincronizar Loyverse puede tardar; a los 90 s la pantalla deja de esperar (el servidor termina igual).
export const refreshCountSales = (storeId: string) =>
  apiRequest<CountSalesRefreshResult>(`${SHEETS}/refresh-sales`, { ...json('POST', { storeId }), signal: timeoutSignal(90_000) });
export const captureCountLine =(lineId: string, input: { requestId: string; countedQuantity: number }) =>
  apiRequest<CaptureCountLineResult>(`${LINES}/${encodeURIComponent(lineId)}/count`, { ...json('POST', input), signal: timeoutSignal(30_000) });
export const approveCountLine = (lineId: string, input: ApproveCountLineInput) =>
  apiRequest<ApproveCountLineResult>(`${LINES}/${encodeURIComponent(lineId)}/approve`, { ...json('POST', input), signal: timeoutSignal(30_000) });
export const rejectCountLine = (lineId: string, reason: string) =>
  apiRequest<{ lineId: string; status: string; replayed: boolean }>(`${LINES}/${encodeURIComponent(lineId)}/reject`, json('POST', { reason }));
export const recountCountLine = (lineId: string, note?: string) =>
  apiRequest<{ lineId: string; status: string; replayed: boolean }>(`${LINES}/${encodeURIComponent(lineId)}/recount`, json('POST', note ? { note } : {}));

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function timeoutSignal(ms: number): AbortSignal | undefined {
  if (typeof AbortController === 'undefined') return undefined;
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
